/**
 * Query key factory.
 *
 * One key for the whole tab, because one request serves it: the headline, the
 * breadth bar and the movers are three readings of the same close, and giving
 * them separate keys would let the page render a headline from one poll above
 * movers from the next.
 */
export const marketOverviewKeys = {
  all: ['market-overview'] as const,
  overview: () => [...marketOverviewKeys.all, 'overview'] as const,
}
